import React, { useRef } from 'react';
import { css } from 'linaria';
import { LinkWithGAPromoClick, Section } from 'common/components';
import { usePromoViewEvent } from 'common/hooks';
import { strictBreakpoints } from 'common/styles/breakpoints';
import { NEW_KITCHEN_CDN_PATH } from '../../new-kitchen-constants';

export const KITCHEN_DESIGNER_HREF = '/3d-planirovshchiki/kuhni/';

type KitchenBannerProps = {
  elementBlock: string;
}

const kitchenBannerImage = css`
  width: 100%;
`;

export const KitchenBanner: React.FC<KitchenBannerProps> = ({ elementBlock }) => {
  const bannerRefs = useRef<HTMLAnchorElement[]>([]);

  const promotion = {
    name: `${elementBlock}_middle`,
    creative: 'Хотите сделать проект сами?',
    position: '1',
  };

  usePromoViewEvent(bannerRefs, elementBlock, [promotion]);

  return (
    <Section>
      <LinkWithGAPromoClick
        bannerRefs={bannerRefs}
        position={0}
        promotion={promotion}
        elementBlock={elementBlock}
        href={KITCHEN_DESIGNER_HREF}
        title="Планировщик кухонь"
      >
        <picture>
          <source srcSet={`${NEW_KITCHEN_CDN_PATH}/banner-ld.jpg/banner-ld-01.jpg`} media={strictBreakpoints['--only-largeDesktop']} />
          <source srcSet={`${NEW_KITCHEN_CDN_PATH}/banner-d.jpg/banner-d-01.jpg`} media={strictBreakpoints['--only-desktop']} />
          <source srcSet={`${NEW_KITCHEN_CDN_PATH}/banner-t.jpg/banner-t-01.jpg`} media={strictBreakpoints['--only-tablet']} />
          <img
            alt="Баннер для конструктора кухни"
            className={kitchenBannerImage}
            src={`${NEW_KITCHEN_CDN_PATH}/banner-m.jpg/banner-m-01.jpg`} />
        </picture>
      </LinkWithGAPromoClick>
    </Section>
  );
}
